







import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import BeaconCarriedList from '@/components/beacon/BeaconCarriedList.vue'

@Component({
  name: 'BeaconCarried',
  components: {
    BeaconCarriedList,
  },
  computed: {},
})
export default class BeaconCarried extends Vue {
  get labelBreadcrumb(): string {
    return this.$t('breadcrumb.beacon_carried_info_manage') as string
  }
}
